import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  CssBaseline,
  Box,
  Button,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Drawer,
} from "@mui/material";
import {
  CommentOutlined,
  UserOutlined,
  FacebookOutlined,
} from "@ant-design/icons";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FloatButton, Modal } from "antd";
import LoginDialog from "./User_Components/Login_Dialog";
import RegisterDialog from "./User_Components/Register_Dialog";
import PropTypes from "prop-types";
import "./Menu_Navbar.css";

function Menu_Navbar() {
  const Navigate = useNavigate();
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth < 960
  );

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mediaQuery = window.matchMedia("(max-width: 959px)");
    const handleMediaChange = (e) => setIsMobile(e.matches);
    setIsMobile(mediaQuery.matches);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleMediaChange);
      return () => mediaQuery.removeEventListener("change", handleMediaChange);
    } else {
      mediaQuery.addListener(handleMediaChange);
      return () => mediaQuery.removeListener(handleMediaChange);
    }
  }, []);

  const [user, setUser] = useState(null);
  const [registerVisible, setRegisterVisible] = useState(false);
  const [loginVisible, setLoginVisible] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleModalCancel = () => {
    setVisible(false);
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      return;
    }

    const fetchUser = async () => {
      try {
        const response = await fetch(
          "https://subd.checkkonproject.com/api/user",
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.ok) {
          const data = await response.json();
          setUser(data);
        } else if (response.status === 401) {
          try {
            const refreshResponse = await fetch(
              "https://subd.checkkonproject.com/api/refresh-token",
              {
                method: "POST",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
            if (refreshResponse.ok) {
              const refreshData = await refreshResponse.json();
              const newToken = refreshData.token;
              if (newToken) {
                localStorage.setItem("access_token", newToken);
                const retryResponse = await fetch(
                  "https://subd.checkkonproject.com/api/user",
                  {
                    method: "GET",
                    headers: {
                      Authorization: `Bearer ${newToken}`,
                    },
                  }
                );
                if (retryResponse.ok) {
                  const retryData = await retryResponse.json();
                  setUser(retryData);
                } else {
                  localStorage.removeItem("access_token");
                  setUser(null);
                }
              } else {
                localStorage.removeItem("access_token");
                setUser(null);
              }
            } else {
              localStorage.removeItem("access_token");
              setUser(null);
            }
          } catch (refreshError) {
            localStorage.removeItem("access_token");
            setUser(null);
          }
        } else {
          console.log("User data retrieval failed");
        }
      } catch (error) {
        console.log("User data retrieval error", error);
      }
    };

    fetchUser();
  }, []);

  const createTypography = (label, text, fontSize = "16px") => (
    <Typography
      variant="body1"
      sx={{
        fontSize,
        fontWeight: 600,
        fontFamily: "'Prompt', 'Sarabun', sans-serif",
      }}
    >
      {label}
    </Typography>
  );

  const handleButtonClick = () => {
    window.location.href = "https://www.facebook.com/MediaLiteracyforCitizen";
  };

  const loginbuttonStyle = {
    background: "linear-gradient(135deg, #5da876 0%, #208b99 100%)",
    border: "none",
    color: "white",
    borderRadius: "999px",
    padding: isMobile ? "6px 14px" : "6px 20px",
    boxShadow: "0 4px 12px rgba(32, 139, 153, 0.22)",
  };

  const registerbuttonStyle = {
    border: "1.5px solid #7BBD8F",
    background: "rgba(123, 189, 143, 0.06)",
    color: "#2e8555",
    borderRadius: "999px",
    padding: isMobile ? "6px 14px" : "6px 20px",
  };

  const showLoginDialog = () => {
    setLoginVisible(true);
  };
  const closeLoginDialog = () => {
    setLoginVisible(false);
  };
  const showRegisterDialog = () => {
    setRegisterVisible(true);
  };
  const closeRegisterDialog = () => {
    setRegisterVisible(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const LoginFinish = (values) => {
    console.log("Received values of form: ", values);
  };
  const RegisterFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const drawerWidth = 280;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleDrawerToggleProfile = async () => {
    if (user.level === 3) {
      Navigate("/User/Profile");
    } else if (user.level === 2) {
      Navigate("/Admin/");
    } else if (user.level === 1) {
      Navigate("/Admin/");
    } else if (user.level === 0) {
      setVisible(true);
    }
  };

  const handleOk = () => {
    localStorage.removeItem("access_token");
    Navigate(`/`);
    window.location.reload();
  };

  const pages = user
    ? [
        { label: "หน้าหลัก", link: "/" },
        { label: "ข่าวสาร", link: "/News_Menu" },
        { label: "บทความ", link: "/Article_Menu" },
        { label: "สื่อชวนแชร์", link: "/MediaShare_Menu" },
        { label: "แจ้งข้อมูลเท็จ", link: "/FakeNews_Menu" },
        { label: "เกี่ยวกับเรา", link: "/About_Us_View" },
      ]
    : [
        { label: "หน้าหลัก", link: "/" },
        { label: "ข่าวสาร", link: "/News_Menu" },
        { label: "บทความ", link: "/Article_Menu" },
        { label: "สื่อชวนแชร์", link: "/MediaShare_Menu" },
        { label: "แจ้งข้อมูลเท็จ", link: "/Warn" },
        { label: "เกี่ยวกับเรา", link: "/About_Us_View" },
      ];

  const drawerMenu = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        py: 2,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          my: 1.5,
          px: 2,
          color: "#2e8555",
          fontWeight: 700,
          fontFamily: "'Prompt', 'Sarabun', sans-serif",
          fontSize: "20px",
        }}
      >
        รู้เท่าทันสื่อ - Checkก่อน
      </Typography>
      <Divider />
      <List sx={{ px: 1.5, pt: 1.5, flexGrow: 1 }}>
        {pages.map((page) => {
          const isActive =
            page.link === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(page.link);
          return (
            <ListItem key={page.label} disablePadding sx={{ mb: 0.75 }}>
              <ListItemButton
                sx={{
                  textAlign: "left",
                  px: 2.5,
                  py: 1.25,
                  borderRadius: "12px",
                  bgcolor: isActive
                    ? "rgba(123, 189, 143, 0.16)"
                    : "transparent",
                }}
                component={Link}
                to={page.link}
              >
                <ListItemText
                  primary={page.label}
                  sx={{ color: isActive ? "#15803d" : "#334155" }}
                  primaryTypographyProps={{
                    sx: {
                      fontSize: "16px",
                      fontFamily: "'Prompt', 'Sarabun', sans-serif",
                      fontWeight: isActive ? 700 : 500,
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      {!user && (
        <Box sx={{ p: 2, borderTop: "1px solid #e2e8f0", display: "flex", flexDirection: "column", gap: 1.25 }}>
          <Button
            fullWidth
            style={{
              ...loginbuttonStyle,
              padding: "10px 16px",
              fontWeight: 600,
            }}
            onClick={showLoginDialog}
          >
            {createTypography("เข้าสู่ระบบ", "", "16px")}
          </Button>
          <Button
            fullWidth
            style={{
              ...registerbuttonStyle,
              padding: "10px 16px",
              fontWeight: 600,
            }}
            onClick={showRegisterDialog}
          >
            {createTypography("สมัครสมาชิก", "", "16px")}
          </Button>
        </Box>
      )}
    </Box>
  );

  const container =
    typeof window !== "undefined" ? window.document.body : undefined;

  return (
    <div>
      <Modal
        title={createTypography("รอแอดมินยืนยัน")}
        open={visible}
        onCancel={handleModalCancel}
        footer={null}
      >
        <p style={{ fontSize: "16px" }}>รอแอดมินยืนยัน</p>
        <Button
          shape="round"
          type="primary"
          className="form-button"
          onClick={handleOk}
        >
          {createTypography("ออกจากระบบ")}
        </Button>
      </Modal>
      <Box className="custom-font">
        <CssBaseline />
        <AppBar
          className="AppBarContainer"
          sx={{
            top: 0,
            left: 0,
            right: 0,
            zIndex: 1100,
            backgroundColor: "rgba(255, 255, 255, 0.96)",
            backdropFilter: "blur(12px)",
            color: "#2e8555",
            minHeight: { xs: "66px", md: "80px" },
            justifyContent: "center",
            boxShadow: "0 4px 20px rgba(15, 23, 42, 0.05)",
            borderBottom: "1px solid rgba(226, 232, 240, 0.85)",
          }}
          position="fixed"
        >
          <Toolbar
            sx={{
              maxWidth: "1440px",
              width: "100%",
              mx: "auto",
              px: { xs: 1.25, sm: 2.5, md: 3 },
              minHeight: { xs: "66px", md: "80px" },
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: { xs: 0.75, sm: 1.25 },
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexGrow: 1,
                minWidth: 0,
              }}
            >
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{
                  mr: { xs: 0.5, sm: 1 },
                  p: 1,
                  display: { xs: "flex", md: "none" },
                }}
              >
                <MenuIcon sx={{ fontSize: "28px" }} />
              </IconButton>
              <Link
                to="/"
                style={{
                  display: "flex",
                  alignItems: "center",
                  textDecoration: "none",
                  minWidth: 0,
                }}
              >
                <img
                  src="https://www.commsci.psu.ac.th/wp-content/uploads/2023/09/logo-web-V2.0.svg"
                  alt="WMO Logo"
                  style={{
                    height: isMobile ? "34px" : "46px",
                    width: "auto",
                    maxWidth: isMobile ? "66px" : "115px",
                    marginRight: isMobile ? "8px" : "14px",
                    objectFit: "contain",
                    flexShrink: 0,
                  }}
                />
                <Typography
                  style={{
                    fontSize: isMobile ? "18px" : "22px",
                    fontFamily: "'Prompt', 'Sarabun', sans-serif",
                    fontWeight: 700,
                    letterSpacing: "0.01em",
                    background:
                      "linear-gradient(135deg, #2e8555 0%, #208b99 100%)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  รู้เท่าทันสื่อ-Checkก่อน
                </Typography>
              </Link>
            </Box>

            <Box component="nav">
              <Drawer
                container={container}
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                  keepMounted: false,
                }}
                sx={{
                  display: { xs: "block", md: "none" },
                  "& .MuiDrawer-paper": {
                    boxSizing: "border-box",
                    width: drawerWidth,
                    maxWidth: "82vw",
                    fontWeight: 600,
                    borderRadius: "0 18px 18px 0",
                  },
                }}
              >
                {drawerMenu}
              </Drawer>
            </Box>

            <Box
              sx={{
                display: { xs: "none", md: "flex" },
                alignItems: "center",
                gap: { md: 0.5, lg: 0.75 },
                mx: 1,
              }}
            >
              {pages.map((page) => {
                const isActive =
                  page.link === "/"
                    ? location.pathname === "/"
                    : location.pathname.startsWith(page.link);
                return (
                  <Button
                    key={page.label}
                    component={Link}
                    to={page.link}
                    sx={{
                      px: { md: 1.5, lg: 2 },
                      py: 0.75,
                      minWidth: "auto",
                      borderRadius: "999px",
                      fontSize: "16px",
                      fontFamily: "'Prompt', 'Sarabun', sans-serif",
                      fontWeight: isActive ? 700 : 500,
                      color: isActive ? "#15803d" : "#475569",
                      backgroundColor: isActive
                        ? "rgba(123, 189, 143, 0.16)"
                        : "transparent",
                      whiteSpace: "nowrap",
                      transition: "all 0.2s ease",
                      "&:hover": {
                        color: "#15803d",
                        backgroundColor: "rgba(123, 189, 143, 0.12)",
                        transform: "translateY(-1px)",
                      },
                    }}
                  >
                    {page.label}
                  </Button>
                );
              })}
            </Box>

            {user ? (
              <Box sx={{ flexGrow: 0, ml: 0.5 }}>
                <IconButton
                  onClick={handleDrawerToggleProfile}
                  sx={{
                    p: 1,
                    bgcolor: "rgba(123, 189, 143, 0.14)",
                    "&:hover": { bgcolor: "rgba(123, 189, 143, 0.25)" },
                  }}
                >
                  <UserOutlined
                    style={{ fontSize: "16px", color: "#2e8555" }}
                  />
                </IconButton>
              </Box>
            ) : (
              <Box sx={{ flexGrow: 0, ml: 0.5 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: isMobile ? "6px" : "10px",
                  }}
                >
                  <Button
                    className="register-button"
                    sx={{
                      display: { xs: "none", sm: "inline-flex" },
                    }}
                    style={{
                      ...registerbuttonStyle,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                    onClick={showRegisterDialog}
                  >
                    {createTypography("สมัครสมาชิก", "", "16px")}
                  </Button>
                  {registerVisible && (
                    <RegisterDialog
                      open={registerVisible}
                      onClose={closeRegisterDialog}
                      handleSubmit={handleSubmit}
                      RegisterFinish={RegisterFinish}
                    />
                  )}
                  <Button
                    className="login-button"
                    style={{
                      ...loginbuttonStyle,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                    onClick={showLoginDialog}
                  >
                    {createTypography("เข้าสู่ระบบ", "", "16px")}
                  </Button>
                  {loginVisible && (
                    <LoginDialog
                      open={loginVisible}
                      onClose={closeLoginDialog}
                      handleSubmit={handleSubmit}
                      RegisterFinish={LoginFinish}
                    />
                  )}
                </div>
              </Box>
            )}
          </Toolbar>
        </AppBar>
        {/* Spacer to offset the fixed AppBar height so page content is never covered */}
        <Toolbar sx={{ minHeight: { xs: "66px", md: "80px" } }} />
        <FloatButton.Group
          trigger="click"
          style={{
            right: isMobile ? 16 : 32,
            bottom: isMobile ? 20 : 32,
          }}
          icon={<CommentOutlined />}
        >
          <FloatButton
            icon={<FacebookOutlined />}
            onClick={handleButtonClick}
          />
        </FloatButton.Group>
      </Box>
    </div>
  );
}

Menu_Navbar.displayName = "Menu_Navbar";
Menu_Navbar.propTypes = {
  window: PropTypes.func,
};

export default Menu_Navbar;
